"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

/**
 * 다크/라이트 테마 전환 Provider
 * - 기본 다크 모드 (tokens.css 기준)
 * - data-theme 속성으로 라이트 모드 활성화 (globals.css @layer base 참조)
 * - localStorage에 사용자 선호 저장
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="data-theme"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
